export function setSubscription (state, data) {
	state.subscription = {
		id: data.id,
		instanceId: data.instanceId,
		paypalSubscriptionId: data.paypalSubscriptionId || null,
		planId: data.planId
	};
}
